module.exports = __webpack_public_path__ + "img/19.8.TSS.51b72bd0.png";